<template>
    <div class=" content-wrap sun res">
        <div class="total-score">
            <span>获得积分</span>
            <span>{{result.total_score}}分</span>
        </div>
        <p>答对{{result.correct_quiz_count}}题，共{{result.total_quiz_count}}题</p>
        <div class="btns-wrap">
            <Button class="btn" @click="() => location.replace('/quiz')">回首页</Button>
            <Button class="btn btn-primary" @click="handleCheck">查看解析</Button>
        </div>
        <div class="qr-wrap">
            <!-- <img src="http://guokrapp-static.guokr.com/FtI3Eb6HAMzmX1zHmw_svJfYCmbt"/> -->
            <div class="img"></div>
            <p>
                <!-- 关注“农业科普发生树” -->
            </p>
            <p>
                <!-- 学习更多科普知识，获取更多积分～ -->
            </p>
        </div>
    </div>
</template>

<script>
import { Button } from 'vant';
export default {
    name: 'Res',
    props: ['result'],
    components: {
        Button
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        handleCheck() {
            this.$emit('getQuesRes')
        }
    }
};
</script>
<style lang="less" scoped>
.res {
    justify-content: center;
    .total-score {
        display: flex;
        position: relative;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 15.3rem;
        span {
            color: #123e7f;
            font-size: 16px;
            &:last-child {
                margin-top: 1rem;
                font-size: 3.6rem;
                font-weight: bold;
            }
            z-index: 1;
        }
        &::before{
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 13.1rem;
            height: 13.1rem;
            background: rgba(255, 255, 255, .8);
            border-radius: 100%;
            border: 1.1rem solid #fbd042;
        }
    }
    p {
        margin-top: 4vh;
        color: #fff;
        font-size: 16px;
        text-align: center;
    }
    .btns-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 3vh;
        .btn {
            &:first-child{
                margin-right:3rem;
            }
        }
    }
    .qr-wrap{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 1rem;
        .img{
            width: 20vh;
            height: 20vh;
            margin-top: 10vh;
            margin-bottom: 2vh;
        }
        p{
            margin:0;
            text-align: center;
            color: #123e7f;
            font-size: 16px;
            line-height: 1.5;
            height: 24px;
        }
    }
}
</style>
